import { Segmented } from 'antd';
import { TransactionFilters } from 'widgets/transactions/model/types';
import { useIntl } from 'react-intl';
import React from 'react';
import { getFilterName } from '../model/utils';
import styles from './Filters.module.scss';

type FiltersProps = {
  filters: TransactionFilters[];
  onSelect?: (filter: TransactionFilters | 'All' | null) => unknown;
};

const Filters: React.FC<FiltersProps> = ({ filters, onSelect }) => {
  const { formatMessage: t } = useIntl();

  const options = [
    { value: 'All', label: t({ id: 'transactions.filter.all' }) },
    ...Object.values(filters)
      .map((filter) => {
        if (filter !== TransactionFilters.QUERY)
          return {
            value: filter,
            label: (
              <div id={`transaction-label__${filter.toLowerCase()}`}>
                {getFilterName({ t, filter })}
              </div>
            ),
          };
      })
      .filter(Boolean) as { value: TransactionFilters; label: React.ReactNode }[],
  ];

  return (
    <div className={styles.filters}>
      <Segmented
        options={options}
        onChange={(value) => onSelect?.(value as TransactionFilters)}
      />
    </div>
  );
};

export default Filters;